import { createAction } from 'redux-actions';
import * as C from '../constants';

export const showModal = createAction(
  C.ACTION_TYPES.SHOW_POPUP,
  (modal: ModalType, info: any) => ({ modal, info })
);

export const closeModal = createAction(C.ACTION_TYPES.CLOSE_POPUP, () => {});



// WEBPACK FOOTER //
// ./app/actions/showModalActionCreators.ts